export const COMPANY_BRANCHES = {
  ANODE: {
    name: 'ANODE ELECTRIC PVT. LTD.',
    gstNumber: '22ABCDE1234F1Z5',
    description: 'MANUFACTURING & SUPPLY OF ELECTRICAL CABLES & WIRES',
    address: 'KHASRA NO. 805/5, PLOT NO. 10, IT PARK, BARGI HILLS, JABALPUR - 482003, MADHYA PRADESH, INDIA',
    tel: '6262002116, 6262002113',
    web: 'www.anocab.com',
    email: 'info@anocab.com',
    logoUrl: 'https://res.cloudinary.com/drpbrn2ax/image/upload/v1757416761/logo2_kpbkwm-removebg-preview_jteu6d.png',
    logo: 'https://res.cloudinary.com/drpbrn2ax/image/upload/v1757416761/logo2_kpbkwm-removebg-preview_jteu6d.png'
  }
};

export const DEFAULT_USER = {
  name: 'Department Head',
  email: 'department.head@anocab.com'
};

export const QUOTATION_MESSAGES = {
  APPROVE: 'Approved by department head',
  REJECT: 'Rejected by department head',
  APPROVE_SUCCESS: 'Quotation approved successfully',
  REJECT_SUCCESS: 'Quotation rejected successfully'
};

export const DEFAULT_BRANCH = 'ANODE';

